import React from "react";
import Paper from "@material-ui/core/Paper";

import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";

import logo from "./images/logo.jpg";

const tileData = [
  {
    img: logo,
    title: "Making Kayaks"
  },
  {
    img: logo,
    title: "Photography"
  }
];

export default class Appbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Paper
        elevation={0}
        square={true}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
          flexDirection: "column",
          marginTop: 25
        }}
      >
        <b>Interests</b>
        <p />
        <div style={{ width: "80vw", maxWidth: 1000 }}>
          <GridList cols={2}>
            {tileData.map(tile => (
              <GridListTile key={tile.img}>
                <img src={tile.img} alt={tile.title} />
                <GridListTileBar title={tile.title} />
              </GridListTile>
            ))}
          </GridList>
        </div>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/interests.js